export const ReservationActionTypes = {
    ADD_RESERVATION: 'ADD_RESERVATION',
    ADD_CANDIDATE: 'ADD_CANDIDATE',
    REMOVE_RESERVATION: 'REMOVE_RESERVATION',
    REMOVE_CANDIDATE: 'REMOVE_CANDIDATE',
    INCREMENT_QTY: 'INCREMENT_QTY',
    DECREMENT_QTY: 'DECREMENT_QTY',
    CLEAR_RESERVATIONS: 'CLEAR_RESERVATIONS',
    UPDATE_USER_RESERVATIONS: 'UPDATE_USER_RESERVATIONS',
};

